export enum MppMaskFormat {
  SHORT = 'short',
  LONG = 'long',
}
